import { format } from 'date-fns';

// Custom hook for date formatting
export const useDateFormatter = () => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Function to format dates from backend (ISO strings) without timezone conversion
  const formatDate = (isoString: string | Date, formatStr = 'MMM dd, yyyy hh:mm a') => {
    if (!isoString) {
      return '';
    }

    try {
      // Convert Date object to ISO string if needed
      const isoDateString = isoString instanceof Date ? isoString.toISOString() : isoString;

      // Use the utility function to display the date without timezone conversion
      return format(isoDateString, formatStr);
    } catch (error) {
      return 'Invalid date';
    }
  };

  return { formatDate, userTimezone };
};
